














































































































































































































































import CheckoutReviewViewModel from "@/chipply/view-model/CheckoutReviewViewModel";
import AddressValidationCard from "@/components/AddressValidationCard.vue";
import OrderSummary from "@/components/OrderSummary.vue";
import StoreLayout from "@/components/StoreLayout.vue";
import { Address, IEcertBalanceInfo, ShippingType, ShippingTypeHelper, Utils, WebHelper } from "chipply-common";
import CCreditCard from "@/components/CCreditCard.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { mask } from "vue-the-mask";
import _, { Cancelable } from "lodash";
import CheckoutBillingSummary from "./checkout/CheckoutBillingSummary.vue";
import CheckoutBillingForm from "./checkout/CheckoutBillingForm.vue";
import CheckoutAdditionalInfoSummary from "./checkout/CheckoutAdditionalInfoSummary.vue";
import CheckoutAdditionalInfoForm from "./checkout/CheckoutAdditionalInfoForm.vue";
import CheckoutPickupDeliverySummary from "./checkout/CheckoutPickupDeliverySummary.vue";
import CheckoutDealerNotes from "./checkout/CheckoutDealerNotes.vue";
import CheckoutReviewRevised from "./checkout/CheckoutReviewRevised.vue";
import CheckoutPickupDeliveryForm from "./checkout/CheckoutPickupDeliveryForm.vue";

@Component({
    components: {
        AddressValidationCard,
        OrderSummary,
        StoreLayout,
        CCreditCard,
        CheckoutBillingSummary,
        CheckoutBillingForm,
        CheckoutAdditionalInfoSummary,
        CheckoutAdditionalInfoForm,
        CheckoutPickupDeliverySummary,
        CheckoutPickupDeliveryForm,
        CheckoutDealerNotes,
        CheckoutReviewRevised,
    },
    directives: {
        mask,
    },
})
export default class CheckoutStepper extends Vue {
    public Utils = Utils;
    public name = "CheckoutStepper";

    @Prop({ type: Number })
    public eventId!: number | null;

    // Component state
    public stepName!: string;
    public currentStepNumber = 1;
    public drawer = false;
    public locationPicked = false;
    public focus = false;
    public reviewComplete = false;
    public preventRepeat = 0;
    public createdRepeat = 0;

    public stepStatus = {
        advancing: false,
        isLoading: false,
        sameAddress: false,
        shipDirect: false,
    };

    //Form validation warnings
    public noteWarning = false;
    public additionalInfoWarning = false;
    public pickupDeliveryWarning = false;
    public billingInfoWarning = false;
    public reviewWarning = false;

    //Step management
    public stepNames: string[] = ["billingInfo", "additionalInfo", "pickupDelivery", "dealerNotes", "checkoutReview"];

    public stepMap: Map<string, boolean> = new Map<string, boolean>([
        ["billingInfo", false],
        ["additionalInfo", false],
        ["pickupDelivery", false],
        ["dealerNotes", false],
        ["checkoutReview", false],
    ]);

    public stepCompleted: boolean[] = [];

    // Layout control
    private navHeight = "90%";
    private containerMinHeight = "";
    private navTopStates = [200, 150, 100, 50, 10];
    private currentNavTopIndex = 0;

    // Throttled handlers
    private handleScrollThrottle!: (() => void) & Cancelable;
    private resizeObserver: ResizeObserver | null = null;

    // Refs and models
    // @ts-ignore
    public $refs!: {
        billingForm: CheckoutBillingForm;
        shippingForm: CheckoutPickupDeliveryForm;
        additionalInfoForm: CheckoutAdditionalInfoForm;
        nav: Vue;
        orderSummary: OrderSummary;
    };

    public vm: CheckoutReviewViewModel = new CheckoutReviewViewModel();
    protected readonly eventIdParamName = "eventid";
    public address: Address = new Address();
    public shippingAddress: Address = new Address();

    get navTopPositionClass() {
        return {
            "top-200": this.currentNavTopIndex === 0,
            "top-150": this.currentNavTopIndex === 1,
            "top-100": this.currentNavTopIndex === 2,
            "top-50": this.currentNavTopIndex === 3,
            "top-10": this.currentNavTopIndex === 4,
        };
    }

    public get mobile() {
        return this.$vuetify.breakpoint.smAndDown;
    }

    public get showAdditionalInfo() {
        return this.vm.fieldValueCollection != null;
    }

    public get showCheckoutReview() {
        if (!this.vm) {
            return false;
        }
        if (Utils.hasValue(this.vm.orderInstructions!) && this.vm.requireTermsAgreement && !this.vm.agreedToTerms) {
            return false;
        }

        if (this.currentStepNumber == this.getStepNumber("checkoutReview")) {
            return true;
        } else {
            return false;
        }
    }

    public get showDealerNotes() {
        if (this.vm.orderInstructions == "" && this.vm.requireTermsAgreement == false) {
            return false;
        } else {
            return true;
        }
    }

    public getStepNumber(stepName: string) {
        if (this.stepNames.indexOf(stepName) < 0) {
            return -1;
        }
        return this.stepNames.indexOf(stepName) + 1;
    }

    public orderPlaced(results: { success: boolean; showConfirmation: boolean }) {
        if (results.success) {
            this.reviewComplete = true;
            this.reviewWarning = false;

            if (results.showConfirmation) {
                location.assign(this.vm.getOrderConfirmationUrl());
            }
        } else {
            this.reviewWarning = true;
        }
    }

    public async mounted() {
        this.subscribeScrollEvents();
        this.setupResizeObserver();

        this.handleScrollThrottle();
    }

    public beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        document.removeEventListener("scroll", this.handleScrollThrottle);
    }

    private subscribeScrollEvents() {
        document.removeEventListener("scroll", this.handleScrollThrottle);
        document.addEventListener("scroll", this.handleScrollThrottle);
    }

    private getVisibleElementHeight(selector: string): number {
        const el = document.querySelector(selector) as HTMLElement;
        if (!el) return 0;

        const rect = el.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Calculate visible portion
        const visibleTop = Math.max(rect.top, 0);
        const visibleBottom = Math.min(rect.bottom, viewportHeight);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);

        return visibleHeight;
    }

    private setupResizeObserver() {
        if (typeof ResizeObserver !== "undefined") {
            this.resizeObserver = new ResizeObserver((entries) => {
                this.handleScroll();
            });

            const orderSummary = this.$refs.orderSummary?.$el;
            if (orderSummary) {
                this.resizeObserver.observe(orderSummary);
            }
        }
    }

    @Watch("currentStepNumber")
    @Watch("stepStatus.sameAddress")
    @Watch("$vuetify.breakpoint.name")
    public async handleScroll() {
        this.updateNavPosition();
        await this.$nextTick();
        await this.updateContainerHeight();
        await this.$nextTick();
        await this.updateNavHeight();
    }

    private async updateContainerHeight() {
        if (this.$vuetify.breakpoint.smAndDown) {
            this.containerMinHeight = "";
        }

        const orderSummary = this.$refs.orderSummary?.$el as HTMLElement;
        if (!orderSummary) {
            return;
        }

        this.containerMinHeight = orderSummary.clientHeight + 40 + "px";
    }

    private async updateNavHeight() {
        if (this.$vuetify.breakpoint.smAndDown) {
            this.navHeight = "90%";
            return;
        }

        const orderSummary = this.$refs.orderSummary?.$el as HTMLElement;
        if (!orderSummary) {
            return;
        }
        const headerVisibleHeight = this.getVisibleElementHeight("div.storeAppBar");
        const footerVisibleHeight = this.getVisibleElementHeight("footer");

        const windowHeight = window.innerHeight;
        // Calculate available height
        const availableHeight = windowHeight - headerVisibleHeight - footerVisibleHeight - 20; // 20px buffer
        // Set nav height to either available height or order summary height, whichever is smaller
        const contentHeight = orderSummary.clientHeight + 5; // 5px buffer, for border, etc.

        // Only set container min-height if needed
        this.navHeight = `${Math.min(availableHeight, contentHeight)}px`;
    }

    private updateNavPosition() {
        if (this.mobile) {
            this.currentNavTopIndex = 4; // Top-10 on mobile
            return;
        }

        this.currentNavTopIndex = 0; // Default to top-200 on desktop
        // const scrollY = window.scrollY;
        // this.currentNavTopIndex = Math.min(Math.floor(scrollY / 50), this.navTopStates.length - 1);
    }

    public async handleApplyCode() {
        if (this.vm instanceof CheckoutReviewViewModel) {
            await this.vm.applyCodeAndRefresh();
        }
    }

    public async handleDeletePromoCode() {
        if (this.vm instanceof CheckoutReviewViewModel) {
            await this.vm.deletePromoCode();
            this.vm.checkWhetherTotalIsCoveredOrNot();
        }
    }

    public async handleDeleteEcertCode(ecert: IEcertBalanceInfo) {
        if (this.vm instanceof CheckoutReviewViewModel) {
            await this.vm.deleteEcertCode(ecert);
            this.vm.checkWhetherTotalIsCoveredOrNot();
        }
    }

    public isCompleted(stepName: string) {
        return this.currentStepNumber > this.getStepNumber(stepName);
    }

    public isCurrentStep(stepName: string) {
        return this.currentStepNumber == this.getStepNumber(stepName);
    }

    private async getNextStep(currentStep: string) {
        var index = this.stepNames.indexOf(currentStep);
        if (index < this.stepNames.length - 1) {
            return this.stepNames[index++];
        } else {
            return currentStep;
        }
    }

    //watchers and method to redraw the stepper content where it will resize correctly for shipping address fields when you refresh at that step instead of cutting off the height
    @Watch("vm.selectedLocation")
    @Watch("stepStatus.sameAddress")
    public async selectedLocationChanged() {
        //only execute this redraw logic if you are on the pickupDelivery step
        if (this.getStepNumber(this.stepName) == this.getStepNumber("pickupDelivery")) {
            await this.$nextTick();
            var pickupDeliverStepNumber = this.getStepNumber("pickupDelivery") - 1;
            var elements = document.getElementsByClassName("v-stepper__wrapper");
            var pickupDeliveryStepContent = elements[pickupDeliverStepNumber] as HTMLElement;

            pickupDeliveryStepContent.style.height = pickupDeliveryStepContent.children[0].clientHeight + "px";
        }
    }

    public async created() {
        this.handleScrollThrottle = _.throttle(
            () => {
                this.handleScroll();
            },
            100,
            { leading: true, trailing: true }
        );

        //var translatedStep = this.stepNames.indexOf(this.stepName) + 1;

        //this.currentStepNumber = translatedStep;
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has("eventId")) {
            this.eventId = Number(urlParams.get("eventId"));
        }
        if (this.eventId) {
            await this.onEventIdChanged();
        }
        if (urlParams.has("stepName")) {
            this.stepName = String(urlParams.get("stepName"));
        }
        if (this.stepName) {
            await this.onStepNameChanged();
        }

        //Saving order to update totals with preset values
        if (this.getStepNumber(this.stepName) < this.getStepNumber("pickupDelivery")) {
            if (this.vm.availablePickups && this.vm.availablePickups.length === 1) {
                this.vm.selectedLocation = this.vm.availablePickups[0];
            }
            await this.updatePickupLocation();
            await this.clearPickupLocation();
        } else if (this.getStepNumber(this.stepName) === this.getStepNumber("pickupDelivery")) {
            await this.clearPickupLocation();
        }

        //see if billing is the same as shipping, don't default to true/box checked if international billing but international shipping not allowed (forceShippingAddress true)
        if (this.vm.order && !this.vm.forceShippingAddress) {
            this.stepStatus.sameAddress = this.vm.order.useBillingAddress;
        }

        //Validate to make sure they're not skipping steps
        await this.validateSteps(this.stepName);
        this.completePrevious();

        this.createdRepeat++;

        this.handleScrollThrottle();
        this.inititalizeEventHandlers();
    }

    private inititalizeEventHandlers() {
        //Catch the browser back button and change the current stepper step
        window.onpopstate = (event: Event) => {
            const backUrl = new URLSearchParams(window.location.search);
            this.stepName = String(backUrl.get("stepName"));
            if (this.stepName == "checkoutReview") {
                this.vm.continueShopping();
            } else {
                var index = this.stepNames.indexOf(this.stepName);
                this.currentStepNumber = index + 1;
            }
        };
    }

    public async validateSteps(currentStep: string) {
        //If the user tries to navigate to a step that doesn't exist, send them to the beginning
        if (this.getStepNumber(currentStep) < 0) {
            this.stepName = "billingInfo";
            this.onStepNameChanged();
            this.$refs.billingForm.resetValidation();
            return;
        }
        if (this.$refs.billingForm && !this.$refs.billingForm.validate()) {
            this.stepName = "billingInfo";
            this.onStepNameChanged();
            this.$refs.billingForm.resetValidation();
            return;
        } else {
            if (this.stepNames.includes("additionalInfo")) {
                if (!this.$refs.additionalInfoForm?.validate()) {
                    this.stepName = "additionalInfo";
                    this.completePrevious();
                    this.onStepNameChanged();
                    return;
                } else {
                    this.stepName = await this.getNextStep("additionalInfo");
                    this.completePrevious();
                }
            }
            if (this.stepNames.includes("pickupDelivery")) {
                if (
                    this.vm.order?.pickupBranchId == null &&
                    this.vm.order?.organizationBranchId == null &&
                    !this.$refs.shippingForm?.validate()
                ) {
                    this.stepName = "pickupDelivery";
                    this.completePrevious();
                    this.onStepNameChanged();
                    return;
                } else if (this.vm.order?.shippingType == null) {
                    this.stepName = "pickupDelivery";
                    this.completePrevious();
                    this.onStepNameChanged();
                    return;
                } else if (this.vm.order?.shippingType == "Shipping" && !this.vm.order?.shippingAddress?.zipCode) {
                    // This happens when the user goes to step 3 and then pastes the link into another tab
                    // This should force them to make a selection and continue past step 3
                    // Previously this code had taken them to step 4 directly which caused the user not to be charged shipping
                    this.completePrevious();
                    this.pickupDeliveryWarning = false;
                    if (this.vm.availablePickups && this.vm.availablePickups.length > 0) {
                        this.vm.selectedLocation = this.vm.availablePickups[0];
                    }
                    return;
                } else {
                    this.stepName = await this.getNextStep("pickupDelivery");
                    this.completePrevious();
                }
            }
            if (this.stepNames.includes("dealerNotes")) {
                if (this.getStepNumber(currentStep) > this.getStepNumber("dealerNotes")) {
                    if (this.vm.requireTermsAgreement && !this.vm.agreedToTerms) {
                        this.stepName = "dealerNotes";
                        this.completePrevious();
                        this.onStepNameChanged();
                        return;
                    } else {
                        this.stepName = await this.getNextStep("dealerNotes");
                        this.completePrevious();
                    }
                } else {
                    this.stepName = await this.getNextStep("dealerNotes");
                    this.completePrevious();
                }
            }
            if (!this.reviewComplete && this.getStepNumber(currentStep) > this.getStepNumber("checkoutReview")) {
                this.stepName = "checkoutReview";
                this.completePrevious();
                this.onStepNameChanged();
                return;
            }
        }
        this.onStepNameChanged();
    }

    public completePrevious() {
        let limit = this.stepNames.indexOf(this.stepName);
        for (let i = 0; i < limit; i++) {
            this.stepCompleted[i] = true;
        }
    }

    public skipCompletedSteps(nextStep: string) {
        try {
            this.stepCompleted.forEach((completed, index) => {
                if (!completed && index != 0) {
                    throw this.stepNames[index];
                }
            });
        } catch (err) {
            return err as string;
        }

        return nextStep;
    }

    public async advanceStepper(selectedStep?: string) {
        this.stepStatus.advancing = true;
        var currentStep = this.stepNames[this.currentStepNumber - 1];
        var nextStep = this.stepNames[this.currentStepNumber];

        if (selectedStep) {
            if (this.getStepNumber(selectedStep) < this.getStepNumber(currentStep)) {
                this.stepName = selectedStep;
                this.onStepNameChanged();
                this.stepStatus.advancing = false;
                return;
            }
        }

        //Clean up steps
        switch (currentStep) {
            case "billingInfo":
                if (!this.$refs.billingForm.validate()) {
                    this.billingInfoWarning = true;
                    this.stepStatus.advancing = false;
                    return;
                } else {
                    await this.savebillingInfo();
                    this.billingInfoWarning = false;
                    this.vm.forceShippingAddress;
                }
                break;
            case "additionalInfo":
                if (!this.$refs.additionalInfoForm?.validate()) {
                    this.additionalInfoWarning = true;
                    this.stepStatus.advancing = false;
                    return;
                } else {
                    await this.vm.saveAdditionalInfo();
                    this.additionalInfoWarning = false;
                }
                break;
            case "pickupDelivery":
                if (this.vm.selectedLocation == null) {
                    if (this.vm.availablePickups && this.vm.availablePickups.length == 1) {
                        this.vm.selectedLocation = this.vm.availablePickups[0];
                    } else {
                        this.pickupDeliveryWarning = true;
                        this.stepStatus.advancing = false;
                        return;
                    }
                }

                if (this.$refs.shippingForm && this.$refs.shippingForm.canValidate()) {
                    if (this.stepStatus.sameAddress && this.vm.order && !this.vm.forceShippingAddress) {
                        this.vm.order.shippingAddress = this.vm.order.billingAddress;
                    }
                    if (!this.$refs.shippingForm.validate()) {
                        this.pickupDeliveryWarning = true;
                        this.stepStatus.advancing = false;
                        return;
                    } else {
                        const saveOrderResults = await this.saveOrder(true);
                        this.pickupDeliveryWarning = false;
                        this.locationPicked = true;
                        if (!saveOrderResults.saveSucceeded) {
                            this.pickupDeliveryWarning = true;
                            this.stepStatus.advancing = false;
                            return;
                        }

                        if (saveOrderResults.fixAddress) {
                            if (this.stepStatus.sameAddress) {
                                this.stepName = "billingInfo";
                                this.onStepNameChanged();
                            }

                            this.stepStatus.advancing = false;
                            return;
                        }
                    }
                } else {
                    this.pickupDeliveryWarning = false;
                    const saveOrderResults = await this.saveOrder(false);
                    if (!saveOrderResults.saveSucceeded) {
                        this.pickupDeliveryWarning = true;
                        this.stepStatus.advancing = false;
                        return;
                    }
                }

                await this.getOrder();

                if (
                    (this.vm.billingAddress?.addressLine1 === "" || this.vm.billingAddress?.addressLine1 === null) &&
                    this.vm.totals!.orderTotal > 0
                ) {
                    this.stepName = "billingInfo";
                    await this.onStepNameChanged();
                    this.$refs.billingForm.resetValidation();
                    this.vm.hideBilling = false;
                    this.stepStatus.advancing = false;
                    return;
                }

                break;
            case "dealerNotes":
                if (this.vm.requireTermsAgreement && !this.vm.agreedToTerms) {
                    this.noteWarning = true;
                    this.stepStatus.advancing = false;
                    return;
                } else {
                    this.noteWarning = false;
                }
                break;
            default:
                break;
        }

        if (nextStep == "pickupDelivery") {
            if (this.vm.forceShippingAddress) {
                this.stepStatus.sameAddress = false;
            }
        }

        this.currentStepNumber++;

        let currentUrl = window.location.href;
        let historyUrl = new URL(currentUrl);
        let replaceUrl = new URL(currentUrl);
        replaceUrl.searchParams.set("stepName", nextStep);

        historyUrl.searchParams.set("stepName", this.stepNames[this.currentStepNumber - 1]);
        try {
            history.pushState(null, "", historyUrl.href);
        } catch (e) {
            console.log("error: ", e);
        }

        history.replaceState(null, "", replaceUrl.toString());

        this.stepCompleted[this.stepNames.indexOf(currentStep)] = true;

        nextStep = this.skipCompletedSteps(nextStep);

        this.stepName = nextStep;
        this.stepStatus.advancing = false;
    }

    public async savebillingInfo() {
        if (this.vm.order) {
            try {
                this.stepStatus.isLoading = true;
                await this.vm.saveCustomerInfo();
            } finally {
                this.stepStatus.isLoading = false;
            }
        }
    }

    private async clearPickupLocation() {
        if (this.vm.order) {
            if (this.vm.availablePickups.length != 1) {
                this.vm.selectedLocation = null;
                this.vm.order.pickupBranchId = null;
                this.vm.order.shippingType = null;
                this.vm.shippingType = null;
                this.vm.order.organizationBranchId = 0;
                this.vm.pickupLocation = null;
            }
        }
    }

    private async handleUpdatePickupLocation(flag?: boolean) {
        await this.updatePickupLocation(flag);
        this.handleScroll();
    }

    public async updatePickupLocation(flag?: boolean) {
        if (!this.vm.order || this.vm.selectedLocation == null) {
            return;
        }

        const { order, selectedLocation } = this.vm;

        order.shippingType = ShippingTypeHelper.toString(selectedLocation!.shippingType);
        if (selectedLocation.shippingType === ShippingType.Shipping) {
            this.stepStatus.shipDirect = true;
            this.vm.pickupLocation = null;
            //unselect any branch related stuff to prevent confusion
            order.pickupBranchId = null;
            order.organizationBranchId = 0;

            // Copy billing address if sameAddress flag is true
            if (this.stepStatus.sameAddress) {
                order.shippingAddress = order.billingAddress;
            }
        } else if (selectedLocation.shippingType === ShippingType.InStorePickup) {
            this.stepStatus.shipDirect = false;
            this.vm.pickupLocation = selectedLocation.description;
            order.pickupBranchId = selectedLocation.id;
            order.organizationBranchId = 0;
        } else if (selectedLocation.shippingType === ShippingType.GroupPickup) {
            this.stepStatus.shipDirect = false;
            this.vm.pickupLocation = selectedLocation.description;
            order.pickupBranchId = null;
            order.organizationBranchId = selectedLocation.id;
        }
        await this.saveOrder(false);
        await this.getOrder();
    }

    private async getOrder() {
        try {
            this.stepStatus.isLoading = true;
            await this.vm.get(this.eventId!);
        } finally {
            this.stepStatus.isLoading = false;
        }
    }

    public async saveOrder(validateAddress: boolean): Promise<{ saveSucceeded: boolean; fixAddress: boolean }> {
        if (this.vm.order) {
            try {
                this.stepStatus.isLoading = true;
                const result = await this.vm.saveOrder(this.stepStatus.sameAddress, validateAddress);
                return result;
            } finally {
                this.stepStatus.isLoading = false;
            }
        }
        return { saveSucceeded: false, fixAddress: false };
    }

    protected validateAddressField(value: string) {
        if (value) {
            return true;
        }
        return "You must enter a value";
    }

    @Watch("stepName")
    public async onStepNameChanged() {
        this.currentStepNumber = this.stepNames.indexOf(this.stepName) + 1;

        let currentUrl = window.location.href;
        let replaceUrl = new URL(currentUrl);
        replaceUrl.searchParams.set("stepName", this.stepName);
        history.replaceState(null, "", replaceUrl.toString());
    }

    @Watch("stepStatus.sameAddress")
    public async sameAddressChanged(value: boolean) {
        if (!value && !this.vm.allowInternationalShipping && this.vm.billingAddress?.country != "US") {
            if (this.vm.order) {
                this.vm.order.shippingAddress = new Address();
            }
        }
    }

    @Watch("eventId")
    public async onEventIdChanged() {
        if (this.eventId) {
            if (this.preventRepeat == 0) {
                this.preventRepeat = 1;
                try {
                    this.stepStatus.isLoading = true;
                    await this.vm.getBrandingInfo(this.eventId);
                    await this.vm.get(this.eventId);
                } finally {
                    this.stepStatus.isLoading = false;
                }

                if (this.vm.orderInstructions == "" && this.vm.requireTermsAgreement === false) {
                    this.stepNames.splice(this.stepNames.indexOf("dealerNotes"), 1);
                }

                if (this.vm.isRequestor) {
                    this.stepNames.splice(this.stepNames.indexOf("pickupDelivery"), 1);
                }

                //Remove the additional info step if there is no roster or require recipient
                if (!this.showAdditionalInfo) {
                    this.stepNames.splice(this.stepNames.indexOf("additionalInfo"), 1);
                }

                //Build the step-completed array
                this.stepCompleted = this.stepNames.map((x) => false);

                this.handleScroll();
            }
        }
    }
}
